import { useEffect, useRef, useState } from "react";
import { useInView, motion } from "framer-motion";
import { STATS } from "@/lib/site";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);
  return <span ref={ref}>{n.toLocaleString()}<span className="text-[0.55em] text-[var(--mint-light)]">{suffix}</span></span>;
};

export const Stats = () => (
  <section data-testid="stats-section" className="relative bg-[var(--navy)] text-white overflow-hidden">
    <div className="absolute inset-0 stripes opacity-30" />
    <div className="container-x relative grid grid-cols-2 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: i * 0.1 }}
          className={`py-14 px-4 lg:px-10 ${i % 2 === 1 ? "border-l border-white/10" : ""} ${i >= 2 ? "border-t border-white/10 lg:border-t-0 lg:border-l" : ""}`}
        >
          <div className="font-display text-4xl font-light tracking-tight sm:text-5xl lg:text-6xl" data-testid={`stat-${i}`}><Counter value={s.value} suffix={s.suffix} /></div>
          <div className="mt-3 font-mono text-[0.62rem] uppercase tracking-[0.22em] text-slate-300">{s.label}</div>
        </motion.div>
      ))}
    </div>
  </section>
);
